<div class="page-container">
<div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3" style="justify-content: space-between;">
      <a href="/statistics" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">Statistiche Giorni</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>
      <div class="d-flex gap-2" style="justify-content: space-between;">
        <div class="ms-auto">
          <div class="statistics-toggle-group">
            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleCertification === 'on_time'"
              (click)="onToggleCertification('on_time')">
              <i class="fas fa-clock"></i>
              On time
            </button>

            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleCertification === 'in_range'"
              (click)="onToggleCertification('in_range')">
              <i class="fas fa-map-pin"></i>
              In range
            </button>
          </div>
        </div>
        <div class="ms-auto">
          <div class="statistics-toggle-group">
            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleTotal === 'totale_affidati'"
              (click)="onToggleTotal('totale_affidati')">
              <i class="fa-solid fa-handshake"></i>
              Su totale affidati
            </button>

            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleTotal === 'totale_consegnati'"
              (click)="onToggleTotal('totale_consegnati')">
              <i class="fas fa-shipping-fast"></i>
              Su totale consegnati
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="fetchStatistics()">

      <div class="d-flex justify-content-between">
        <div class="d-flex flex-wrap gap-3 mb-3">

          <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
            <label class="form-label">Clienti</label>
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
                name="clients"
                [placeholder]="'Seleziona clienti'"
                [settings]="dropdownSettingsClient"
                [data]="filteredClients"
                [(ngModel)]="selectedClients"
                [ngModelOptions]="{standalone: true}"
                (onSelect)="onClientsChange()"
                (onDeSelect)="onClientsChange()"
                (onSelectAll)="selectAllClients()"
                (onDeSelectAll)="deselectAllClients()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
            <label class="form-label">Marchi</label>
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
                name="brands"
                [placeholder]="'Seleziona marchi'"
                [settings]="dropdownSettingsBrand"
                [data]="filteredBrands"
                [(ngModel)]="selectedBrands"
                [ngModelOptions]="{standalone: true}"
                >
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Tipologia</label>
            <select class="form-select" [(ngModel)]="scheduleType" name="scheduleType">
              <option value="">Tutte</option>
              <option value="AxA">DMDC</option>
              <option value="AxB">A*B</option>
              <option value="AxC">A*C</option>
              <option value="AxD">A*D</option>
            </select>
          </div>

          <!-- Filtro Night/Day -->
          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Night/Day</label>
            <select class="form-select" [(ngModel)]="scheduleIsNight" name="scheduleIsNight" [disabled]="scheduleType !== 'AxB'">
              <option value="">Tutti</option>
              <option value="Y">Night</option>
              <option value="N">Day</option>
            </select>
          </div>

          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Metodo</label>
            <select class="form-select" [(ngModel)]="scheduleMethod" name="scheduleMethod" [disabled]="scheduleType !== 'AxB'">
              <option value="">Tutti</option>
              <option value="BY_ROAD">Via terra</option>
              <option value="BY_AIR">Via aerea</option>
            </select>
          </div>

          <!-- <div class="filter-item" style="min-width: 130px;">
            <label class="form-label">Data Inizio</label>
            <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">
          </div> -->

          <!-- <div class="filter-item" style="min-width: 130px;">
            <label class="form-label">Data Fine</label>
            <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
          </div> -->

          <div class="mb-2 d-flex">
            <div class="filter-item" style="min-width: 180px;">
              <label style="padding-left:30px;" class="form-label d-block">Data Inizio</label>
              <div class="d-flex align-items-center">
                <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">

              </div>
            </div>

            <div class="filter-item" style="min-width: 180px;">
              <label class="form-label">Data Fine</label>
              <div class="d-flex align-items-center">
                <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
                <button class="date-nav-btn" type="button" (click)="incrementStartDate(); incrementEndDate()" title="Giorno successivo">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-item mt-3">
          <div class="custom-switch-btn d-flex align-items-center">
            <i class="fa-solid fa-scale-unbalanced me-2"></i>
            <label class="form-check-label me-2" for="showJustifyParcels" style="cursor: pointer;">
              Colli giustificati
            </label>
            <div class="form-check form-switch m-0" style="cursor: pointer;">
              <input
                style="cursor: pointer;"
                class="form-check-input"
                type="checkbox"
                id="showJustifyParcels"
                [(ngModel)]="showJustifyParcels"
                name="showJustifyParcels"
                (change)="fetchStatistics()" />
            </div>
          </div>
        </div>
      </div>

      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">Applica Filtri</button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center p-3 m-3">
    {{ error }}
  </div>  

  <!-- WARNING -->
  <div *ngIf="warning" class="alert alert-warning p-3 m-3">
    <div class="d-flex align-items-center">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ warning }}</span>
    </div>
  </div>
  
  <div class="row px-3 mb-3">
    <div class="col-12 d-flex align-items-center justify-content-end gap-2 flex-wrap flex-md-nowrap">      
      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-hash"></i></span>
        <input type="text" class="form-control" [value]="totalItems" readonly style="max-width: 80px;">
      </div>

      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-view-list"></i></span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let size of [5, 10, 25, 50, 100]" [value]="size">{{size}}</option>
        </select>
      </div>
      
      <button class="btn btn-green w-auto"
              type="button"
              (click)="exportStatisticsToExcel()"
              title="Esporta Excel">
        <i class="fas fa-file-excel"></i>
      </button>
      
    </div>
  </div>
  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row mx-3">
    <div class="card table-container">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-bordered text-center">
            <thead class="bg-light">
  <tr>
    <!-- Sempre visibili -->
    <th>#</th>
    <th (click)="setSort('dataAffido')" style="cursor:pointer">
      Data affido
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'dataAffido' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'dataAffido' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'dataAffido'
      }"></i>
    </th>
    <th (click)="setSort('affidati')" style="cursor:pointer">
      Affidati
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'affidati' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'affidati' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'affidati'
      }"></i>
    </th>

    <th colspan="2" class="text-center">Consegnati</th>
    <th *ngIf="selectedToggleCertification === 'on_time'" colspan="2" class="text-center">Consegnati on time</th>
    <th *ngIf="selectedToggleCertification === 'in_range'"  colspan="2" class="text-center">Consegnati in range</th>
    <th colspan="2" class="text-center">Consegnati on time e in range</th>
  </tr>
  <tr>
    <th style="background-color: white !important;" colspan="3"></th>

    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('consegnati')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnati' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnati' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnati'
      }"></i>
    </th>
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('percentualeConsegnati')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeConsegnati' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeConsegnati' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeConsegnati'
      }"></i>
    </th>

    <!-- Se on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleCertification === 'on_time'" 
        (click)="setSort('consegnatiInOrario')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnatiInOrario' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnatiInOrario' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnatiInOrario'
      }"></i>
    </th>
    <!-- Se totale_affidati + on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'" 
        (click)="setSort('percentualeAffidatiConsegnatiInOrario')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeAffidatiConsegnatiInOrario' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeAffidatiConsegnatiInOrario' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeAffidatiConsegnatiInOrario'
      }"></i>
    </th>
    <!-- Se totale_consegnati + on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'" 
        (click)="setSort('percentualeConsegnatiInOrario')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeConsegnatiInOrario' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeConsegnatiInOrario' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeConsegnatiInOrario'
      }"></i>
    </th>

    <!-- Se in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleCertification === 'in_range'" 
        (click)="setSort('inRange')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'inRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'inRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'inRange'
      }"></i>
    </th>
    <!-- Se totale_affidati + in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'" 
        (click)="setSort('percentualeAffidatiConsegnatiInRange')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeAffidatiConsegnatiInRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeAffidatiConsegnatiInRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeAffidatiConsegnatiInRange'
      }"></i>
    </th>
    <!-- Se totale_consegnati + in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'" 
        (click)="setSort('percentualeConsegnatiInRange')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeConsegnatiInRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeConsegnatiInRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeConsegnatiInRange'
      }"></i>
    </th>


    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('consegnatiInOrarioInRange')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnatiInOrarioInRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnatiInOrarioInRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnatiInOrarioInRange'
      }"></i>
    </th>
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati'" (click)="setSort('percentualeAffidatiConsegnatiInOrarioInRange')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeAffidatiConsegnatiInOrarioInRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeAffidatiConsegnatiInOrarioInRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeAffidatiConsegnatiInOrarioInRange'
      }"></i>
    </th>  
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati'" (click)="setSort('percentualeConsegnatiInOrarioInRange')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percentualeConsegnatiInOrarioInRange' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percentualeConsegnatiInOrarioInRange' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percentualeConsegnatiInOrarioInRange'
      }"></i>
    </th>  

  </tr>
</thead>

<tbody>
  <tr *ngFor="let stat of getPaginatedStats(); let i = index">
    <!-- Sempre visibili -->
    <td>{{ pageIndex * pageSize + i + 1 }}</td>
    <td>{{ stat.dataAffido | date: 'dd/MM/yyyy' }}</td>
    <td>{{ stat.affidati }}</td>

    <td>{{ stat.consegnati }}</td>
    <td>{{ stat.percentualeConsegnati | number: '1.0-2' }}%</td>

    <!-- Se on_time -->
    <td *ngIf="selectedToggleCertification === 'on_time'">
      {{ stat.consegnatiInOrario }}
    </td>    
    <!-- Se totale_affidati + on_time -->
    <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'">
      {{ stat.percentualeAffidatiConsegnatiInOrario | number: '1.0-2' }}%
    </td>
    <!-- totale_consegnati + on_time -->
    <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'">
      {{ stat.percentualeConsegnatiInOrario | number: '1.0-2' }}%
    </td>

    <!-- Se in_range -->
    <td *ngIf="selectedToggleCertification === 'in_range'">
      {{ stat.inRange }}
    </td>
    <!-- Se totale_affidati + in_range -->
    <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'">
      {{ stat.percentualeAffidatiConsegnatiInRange | number: '1.0-2' }}%
    </td>
    <!-- totale_consegnati + in_range -->
    <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'">
      {{ stat.percentualeConsegnatiInRange | number: '1.0-2' }}%
    </td>

    <td>{{ stat.consegnatiInOrarioInRange }}</td>
    <td *ngIf="selectedToggleTotal === 'totale_affidati'">{{ stat.percentualeAffidatiConsegnatiInOrarioInRange | number: '1.0-2' }}%</td>
    <td *ngIf="selectedToggleTotal === 'totale_consegnati'">{{ stat.percentualeConsegnatiInOrarioInRange | number: '1.0-2' }}%</td>

  </tr>

  <tr *ngIf="getPaginatedStats().length === 0">
    <td colspan="6" class="text-center py-3">Nessuna statistica trovata</td>
  </tr>
</tbody>

    </table>        </div>
        <!-- Paginazione Bootstrap -->
        <div class="d-flex flex-column flex-md-row justify-content-end align-items-center p-2 gap-2">
      <nav aria-label="Paginazione tabella" *ngIf="totalItems > 0">
        <ul class="pagination mb-0">
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="firstPage()">
              <i class="bi bi-chevron-double-left"></i>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <span class="page-link">
                Pagina {{getNumberOfPages() === 0 ? 1 : pageIndex + 1}} di
                {{getNumberOfPages() === 0 ? 1 : getNumberOfPages()}}
            </span>
          </li>
          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>          
          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="lastPage()">
              <i class="bi bi-chevron-double-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
      </div>
    </div>
  </div>


  



</div>